module.exports = __webpack_public_path__ + "media/goal.0f3d2d62.mp3";